import { isLandingOnlyMode } from './runtime'

const PUBLIC_EXACT_PATHS = new Set([
  '/404',
  '/500',
  '/502',
  '/error',
  '/resale-strategy',
  '/privacy-policy',
  '/terms-of-service',
])

export function isWelcomeRoute(pathname: string): boolean {
  if (pathname === '/' && isLandingOnlyMode()) {
    return true
  }

  return pathname === '/welcome' || pathname.startsWith('/welcome/')
}

const PUBLIC_PREFIX_PATHS = ['/tai-lieu']

export function isPublicAppRoute(pathname: string): boolean {
  if (isWelcomeRoute(pathname)) {
    return true
  }

  if (pathname.startsWith('/auth/')) {
    return true
  }

  if (
    PUBLIC_PREFIX_PATHS.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    )
  ) {
    return true
  }

  return PUBLIC_EXACT_PATHS.has(pathname)
}
